export default "__VITE_ASSET__B5vcm4E1__"